<template>
  <div class="dropdown item">
    <button
      :class="['btn no-bg dropdown-toggle text-secondary shake', className]"
      type="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false">
      <i :class="[icon, iconClass]"/>
      <span :class="['name', textClass]">{{ text }}</span>
    </button>
    <div class="dropdown-menu dropdown-menu-right">
      <a
        v-for="(item, index) in items"
        :key="index"
        :class="['dropdown-item', { disabled: item.disabled }]"
        @click="onSelect(item.value)"
      >
        <i
          v-if="item.icon"
          :class="[item.icon, item.iconClassName]"
          :style="item.iconStyle"/>
        <span :class="[item.textClassName]">
          {{ item.text }}
        </span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: ['className', 'icon', 'iconClass', 'iconStyle', 'text', 'textClass', 'items'],

  methods: {
    onSelect (value) {
      this.$emit('onSelect', value)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseActionDropdown.vue